// src/components/Footer.jsx - Pie de Página Institucional Mejorado English EOH
import React from 'react';

function Footer({ onOpenAbout, onOpenPrivacy, onOpenInstall }) {
  return (
    <footer className="print:hidden bg-slate-950 border-t border-slate-800 text-slate-400 text-xs mt-20 pt-12 pb-8 px-6">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 mb-10 text-left">
        
        {/* Columna 1: Marca, Identidad y Estado */}
        <div className="space-y-4">
          <div className="flex items-center space-x-3">
            <div className="bg-blue-600 text-white font-black px-2.5 py-1 rounded-xl text-sm shadow-md">
              EOH
            </div>
            <div>
              <span className="font-extrabold text-white text-lg tracking-tight block">
                English EOH
              </span>
              <span className="text-[10px] text-blue-400 font-medium">Task-Based Learning</span>
            </div>
          </div>

          <p className="text-slate-400 text-xs leading-relaxed">
            Plataforma interactiva de aprendizaje del idioma inglés con Inteligencia Artificial, diseñada exclusivamente para la comunidad educativa de la IE Enrique Olaya Herrera.
          </p>

          <div className="inline-flex items-center space-x-2 text-[11px] text-emerald-400 font-bold bg-emerald-950/80 border border-emerald-500/40 px-3 py-1.5 rounded-full shadow-sm">
            <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse"></span>
            <span>Sistema Operativo & Sincronizado</span>
          </div>
        </div>

        {/* Columna 2: Enlaces Rápidos y Navegación */}
        <div className="space-y-3">
          <h4 className="font-bold text-white uppercase tracking-wider text-xs border-b border-slate-800 pb-2">
            Navegación e Información
          </h4>
          <ul className="space-y-2.5 text-slate-300 font-medium">
                        <li>
              <button 
                onClick={onOpenInstall} 
                className="hover:text-emerald-400 text-emerald-400 font-bold transition flex items-center gap-2 group text-xs"
              >
                <span>📱</span> <span className="group-hover:translate-x-1 transition-transform">Instalar App en Celular (PWA) 📲</span>
              </button>
            </li>
            <li>
              <button 
                onClick={onOpenAbout} 
                className="hover:text-sky-400 transition flex items-center gap-2 group text-xs"
              >
                <span>📘</span> <span className="group-hover:translate-x-1 transition-transform">Acerca de English EOH</span>
              </button>
            </li>
            <li>
              <button 
                onClick={onOpenPrivacy} 
                className="hover:text-sky-400 transition flex items-center gap-2 group text-xs"
              >
                <span>🛡️</span> <span className="group-hover:translate-x-1 transition-transform">Políticas de Privacidad (Habeas Data)</span>
              </button>
            </li>
            <li>
              <span className="text-slate-500 flex items-center gap-2 text-xs">
                <span>📚</span> Malla Curricular 2026 (Grados 6°, 7°, 9°)
              </span>
            </li>
          </ul>
        </div>

        {/* Columna 3: Datos Oficiales de la Institución */}
        <div className="bg-slate-900/60 border border-slate-800/80 p-5 rounded-2xl space-y-3 shadow-lg">
          <h4 className="font-bold text-white uppercase tracking-wider text-xs border-b border-slate-800 pb-2">
            Institución Educativa Enrique Olaya Herrera
          </h4>
          <div className="text-slate-400 text-[11px] leading-relaxed space-y-1">
            <p><strong>Resoluciones:</strong> 16191 de nov 27 de 2002 y 0759 de dic 3 de 2004</p>
            <p><strong>NIT:</strong> 811.020.435-8 | <strong>DANE:</strong> 10500100552501</p>
            <p><strong>Núcleo Educativo:</strong> 916 | Barrio Manrique Oriental</p>
            <p>Medellín, Antioquia - Colombia</p>
          </div>
          <p className="text-blue-400 font-semibold italic text-xs pt-1 border-t border-slate-800/60">
            "Ciencia, Cultura y Derechos Humanos"
          </p>
        </div>

      </div>

      {/* Pie de Página Inferior (Copyright & Créditos) */}
      <div className="max-w-6xl mx-auto border-t border-slate-800/80 pt-6 flex justify-between items-center flex-wrap gap-4 text-[11px] text-slate-500">
        <div>
          © 2026 Institución Educativa Enrique Olaya Herrera. Todos los derechos reservados.
        </div>
        <div>
          Diseñado por <strong className="text-slate-300 font-bold">Lic. Didier Antonio Alvarez Ramos, M.Sc.</strong>
        </div>
      </div>
    </footer>
  );
}

export default Footer;